import styled from 'styled-components'
import ButtonComponent from 'components/atoms/Button'
import DrawerComponent from 'react-modern-drawer'
import { Colors, Fonts } from 'theme'
import { Box } from '@chakra-ui/react'
import {
  white,
  purple,
  error,
  gray,
  errorSec,
  yellowSec,
  yellowFour,
  purpleDisabled
} from '@qirapagos/web/src/theme/colors'
import { StyleSheet } from 'react-native'

export const Drawer = styled(DrawerComponent)`
  width: 450px !important;
`

export const DrawerContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  background: white;
`

export const PDFContainer = styled.div`
  width: 100%;
  justify-items: center;
  flex: 1; /* ocupa el espacio restante para empujar el botón al fondo */
`

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 100%;
  min-height: 100px;
  background: white;
  z-index: 1;
  margin-top: 20px;
`

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  z-index: 2;
`

export const ReceiptDetailText = styled.p`
  font-size: ${Fonts.SIZES.XLARGE};
  font-weight: 500;
  margin: 0;
`

export const DataContainer = styled.div`
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto;
  justify-content: space-around;
  margin-bottom: 20px;
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-bottom: 10px;
  margin-top: auto;
  background: white;
`

export const DownloadButton = styled(ButtonComponent)`
  width: 50%;
  height: 55px;
  padding-left: 10px;
  padding-right: 10px;
`

export const ToastRenderItem = styled(Box)`
  display: flex;
  background-color: ${Colors.purple};
  color: ${Colors.white};
  padding: 10px;
  align-items: center;
  justify-content: space-around;
`

export const ErrorContainer = styled.div`
  text-align: center;
  background-color: ${errorSec};
  justify-content: center;
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 10px;
  padding-bottom: 20px;
  width: 95%;
`

export const ErrorLegend = styled.div`
  color: ${gray};
  font-size: 14px;
`

export const ErrorState = styled.div`
  display: flex;
  justify-content: center;
  color: ${error};
  align-items: center;
  gap: 10px;
  font-weight: 600;
  font-size: 14px;
  padding-bottom: 20px;
  width: 100%;
`

export const LinkHelp = styled.div`
  color: ${purple};
  margin-top: 20px;
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
  align-self: center;
`

export const PendingContainer = styled.div`
  text-align: center;
  background-color: ${yellowSec};
  padding-left: 40px;
  padding-right: 40px;
  padding-top: 10px;
  padding-bottom: 20px;
  width: 95%;
`

export const PendingLegend = styled.div`
  color: ${gray};
  font-size: 14px;
`

export const PendingState = styled.div`
  display: flex;
  justify-content: center;
  color: ${yellowFour};
  align-items: center;
  gap: 10px;
  font-weight: 600;
  font-size: 14px;
  padding-bottom: 20px;
  width: 100%;
`

export const OutOfHoursContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`

export const OutOfHoursText = styled.p<{ bold?: boolean }>`
  color: ${Colors.gray};
  font-size: 16px;
  text-align: center;
  line-height: 28px;
  font-weight: ${props => (props.bold ? 'bold' : 'normal')};
`

export const CancelContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  height: 100%;
  padding: 20px;
`

export const CancelMiddleContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  text-align: center;
`

export const CancelIcon = styled.div`
  margin-bottom: 5px;
`

export const CancelBoldText = styled.p`
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 10px;
`

export const CancelRegularText = styled.p`
  width: 80%;
  font-size: 14px;
  color: ${Colors.gray};
  line-height: 22px;
`

export const CancelButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 70%;
  align-self: anchor-center;
`

export const styles = StyleSheet.create({
  title: {
    flex: 1,
    textAlign: 'right',
    marginRight: 10
  },
  flatList: {
    marginTop: 20
  },
  contentStyle: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  loading: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 50
  }
})
